import { z } from 'zod';
// Shared between backend (controller DTO + use case input) and frontend
// (admin picker + API client). Events module (§6.7) — S3 staffing (task 3.1's
// sibling shared-schema task, mirrors event-guest-schemas.ts exactly).
// ── Assign staff (R3.1) ──────────────────────────────────────────────────────
export const AssignEventStaffRequestSchema = z.object({
    userId: z.string().uuid(),
    // Free-text role label (e.g. "valet") — optional, not the identity RoleName enum.
    role: z.string().trim().min(1).max(100).nullable().optional(),
});
// ── Response shapes ──────────────────────────────────────────────────────────
export const EventStaffAssignmentResponseSchema = z.object({
    id: z.string().uuid(),
    organizationId: z.string().uuid(),
    eventId: z.string().uuid(),
    userId: z.string().uuid(),
    role: z.string().nullable(),
    assignedAt: z.string(),
    createdAt: z.string(),
    updatedAt: z.string(),
});
export const ListEventStaffResponseSchema = z.object({
    staff: z.array(EventStaffAssignmentResponseSchema),
});
//# sourceMappingURL=event-staff-schemas.js.map